export { AmplifyAngularModule } from './src/aws-amplify-angular.module';
export { AmplifyIonicModule } from './src/aws-amplify-ionic-module';
export { AmplifyService, AmplifyModules } from './src/providers';
//# sourceMappingURL=index.js.map